import { render, staticRenderFns } from "./SpectrumTable.vue?vue&type=template&id=183f3d43&scoped=true&"
import script from "./SpectrumTable.vue?vue&type=script&lang=js&"
export * from "./SpectrumTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f3d43",
  null
  
)

export default component.exports